export default __webpack_public_path__ + "static/media/ic_map_global_hub.882a13cb.svg";